'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

const Moment = require('moment');
const MomentRange = require('moment-range');

const moment = MomentRange.extendMoment(Moment);

import routes from './statistics.routes';

export class StatisticsComponent {

  constructor(User, ReferralService, TestimonialService, MeetingService, GuestService, AttendanceService, DTOptionsBuilder) {
    'ngInject';

    this.ReferralService = ReferralService;
    this.TestimonialService = TestimonialService;
    this.MeetingService = MeetingService;
    this.GuestService = GuestService;
    this.AttendanceService = AttendanceService;
    this.User = User;

    let date = new Date(), y = date.getFullYear(), m = date.getMonth();
    this.from = new Date(y, m, 1);
    this.to = new Date(y, m + 1, 0);

    this.getData();

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('responsive', true)
      .withOption('order', [0, 'asc'])
      .withOption('pageLength', 50)
      .withOption('buttons',[{
        extend: 'excel',
        title: 'Member Statistics'
      },{
        extend: 'csv',
        title: 'Member Statistics'
      },{
        title: 'Member Statistics',
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'landscape',
        pageSize: 'LETTER'
      },'print']);
  }

  getData() {
    this.range = moment().range(this.from, this.to);

    this.data = [];

    let count = 0;

    let data = {};
    let userIdMap = {};
    let userData = {};

    const doneHook = (key, hookData) => {
      data[key] = hookData;
      count++;

      if (count === 5) {

        data.user.forEach(user => {
          userIdMap[user._id] = user.firstName + ' ' + user.lastName + " - " + user.companyName;
          userData[user._id] = {
            referralsGiven: 0,
            referralsReceived: 0,
            testimonialsGiven: 0,
            oneOnOnes: 0,
            guests: 0
          }
        });

        data.referral.forEach(referral => {

          let oRefGiven = (referral.meta.creationUser) ? userData[referral.meta.creationUser._id] : undefined;
          let oRefReceived = (referral.for) ? userData[referral.for._id] : undefined;

          if (oRefGiven && this.range.contains(new Date(referral.meta.creationDate)))
            oRefGiven.referralsGiven++;

          if (oRefReceived  && this.range.contains(new Date(referral.meta.creationDate)))
            oRefReceived.referralsReceived++;
        });

        data.testimonial.forEach(testimonial => {
          let oRef = (testimonial.meta.creationUser) ? userData[testimonial.meta.creationUser._id]: undefined;

          if (oRef && this.range.contains(new Date(testimonial.meta.creationDate)))
            oRef.testimonialsGiven++;
        });

        data.meeting.forEach(meeting => {
//          let oRefWith = userData[meeting.with];
          let oRefCreator = userData[meeting.meta.creationUser];

  //        if (oRefWith)
   //         oRefWith.oneOnOnes++;

          if (oRefCreator && this.range.contains(new Date(meeting.meta.creationDate)))
            oRefCreator.oneOnOnes++;
        });

        data.guest.forEach(guest => {
          let oRef = userData[guest.member];

          if (oRef && guest.type == 'guest' && !guest.recurringGuest && this.range.contains(new Date(guest.meta.creationDate)))
            oRef.guests++;
        });

        data.user.forEach(user => {
          this.data.push({
            name: userIdMap[user._id],
            referralsGiven: userData[user._id].referralsGiven,
            referralsReceived: userData[user._id].referralsReceived,
            testimonialsGiven: userData[user._id].testimonialsGiven,
            oneOnOnes: userData[user._id].oneOnOnes,
            guests: userData[user._id].guests
          });
        });

      }
    };

    this.ReferralService.query(data => doneHook('referral', data));
    this.TestimonialService.query(data => doneHook('testimonial', data));
    this.MeetingService.query(data => doneHook('meeting', data));
    this.AttendanceService.query(data => doneHook('guest', data));
    this.User.query(data => doneHook('user', data));
  }
}

export default angular.module('conduuApp.statistics', [uiRouter])
  .config(routes)
  .component('statistics', {
    template: require('./statistics.html'),
    controller: StatisticsComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/statistics/statistics.component.js